/* eslint-disable no-unused-vars */
// LogRocket only runs in prod, so the actual `logrocket` package is lazy-
// loaded. In dev/staging the exported object is a no-op stub so we pay
// zero bundle cost for session replay that will never run. Callers mutate
// this object in place (via Object.assign) when they want the real module.
//
// Call `ensureLogRocketLoaded()` before touching the real API (e.g. before
// `init()` or `getSessionURL()`). Synchronous calls like `LogRocket.log(...)`
// just no-op on the stub until the real module swaps in.
//
// Tradeoff (explicit product decision): early `LogRocket.log/track/identify`
// calls made before the lazy chunk resolves are dropped. This is acceptable
// because session replay is only meaningful after `init()` fires anyway,
// and because dev builds never load LogRocket at all. If we ever need
// queue-and-replay semantics, swap the method stubs for queueing wrappers.

const noop = () => {};

const LogRocket = {
	init: noop,
	identify: noop,
	track: noop,
	log: noop,
	info: noop,
	warn: noop,
	error: noop,
	debug: noop,
	captureException: noop,
	captureMessage: noop,
	addListener: noop,
	getSessionURL: (cb) => {
		if (typeof cb === 'function') cb(null);
	},
};

let loadPromise = null;
export function ensureLogRocketLoaded() {
	if (!loadPromise) {
		loadPromise = import(/* webpackChunkName: "logrocket" */ 'logrocket').then(
			(mod) => {
				Object.assign(LogRocket, mod.default || mod);
				return LogRocket;
			},
		);
	}
	return loadPromise;
}

export default LogRocket;
